import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{this.tagId}}",{ moduleName: "discourse/components/tag-drop-link.hbs" })